customElements.component = "yc-products";

class YCProducts extends HTMLElement {
  constructor() {
    super();

    this.variables = {
      productsWrap: '.yc-products-ds__products-wrap',
      productsGrid: '.yc-products-ds__products-grid',
      loadMoreBtn: '.js-load-more',
      loading: 'loading'
    }

    this.loadMoreBtn = this.querySelectorAll(this.variables.loadMoreBtn);
  }

  addEventListeners() {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.forEach(item => {
        item.addEventListener("click", async (e) => {
          this.classList.add(this.variables.loading)
          
          const response = await fetch(`${window.location.origin}${e.target.closest(this.variables.loadMoreBtn).dataset.url}`);
          const text = await response.text();
          const html = document.createElement('div');
          html.innerHTML = text;
  
          const view = e.target.closest(this.variables.productsWrap).dataset.view;
          const updatedCollection = html.querySelector(`[data-view=${view}] ${this.variables.productsGrid}`);
          const itemsGrid = document.querySelector(`[data-view=${view}] ${this.variables.productsGrid}`);
          const updatedLoadMore = html.querySelector(`[data-view=${view}] ${this.variables.loadMoreBtn}`);
          const loadMoreBtn = document.querySelector(`[data-view=${view}] ${this.variables.loadMoreBtn}`);

          const currentPage = Number(updatedLoadMore.dataset.currentPage) || 1;
          const totalPages = Number(updatedLoadMore.dataset.totalPages) || 1;

          if (updatedCollection) {
            itemsGrid.innerHTML += updatedCollection.innerHTML;
          }
          
          this.classList.remove(this.variables.loading);

          if(updatedLoadMore && currentPage < totalPages) {
            loadMoreBtn.dataset.url = updatedLoadMore.dataset.url;
          } else {
            loadMoreBtn.style.display = 'none';
          }
        })
      })
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }
}

if (!customElements.get(customElements.component)) {
  customElements.define(customElements.component, YCProducts);
}